<script setup>
import { getProductRecommendations } from '#wa/services/productServices'

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
})
const { $axios, $auth } = useNuxtApp()
const emit = defineEmits(['recommendations-fetched'])
const recommendedProducts = ref([])

recommendedProducts.value = await getProductRecommendations(
  $axios,
  $auth,
  props.product?.product_id || null,
  12,
)
emit('recommendations-fetched')
</script>

<template>
  <section class="recommendations">
    <ProductGridCarousel
      :carousel-id="`${product.product_id}-recommendations`"
      :items="recommendedProducts"
    />
  </section>
</template>
